<template lang="pug">
  div(v-bind:class="{userAvatar: $store.state.user.cover_photo}", v-bind:style="{ 'background': 'url(' + $store.state.user.cover_photo + ') center center no-repeat no-repeat' , 'background-size': 'cover', 'position': 'relative'}")
    div(class="blackGradient", v-if="$store.state.user.cover_photo")
    mu-list(v-if="$store.state.user.scope")
      mu-list-item(:title="upperFirstChar", :describeText="$store.state.user.scope.diabetes_type.diabetes_type ? $store.state.user.scope.diabetes_type.diabetes_type : null", disabled)
        mu-avatar.blue(v-if="!$store.state.user.scope.profile_large", :src="$store.state.user.scope.profile_large", slot="left", color="white", backgroundColor="grey") {{upperTwoInitials}}
        mu-avatar(v-else, :src="$store.state.user.scope.profile_large", slot="left", color="white", backgroundColor="grey")
</template>
<script>



  export default {
    name: 'user-avatar',
    data () {
      return {

      }
    },
    computed: {
      upperFirstChar: {
        get() {
          let self = this, firstname, surname;
          firstname = (self.$store.state.user.scope.firstname.charAt(0).toUpperCase() + self.$store.state.user.scope.firstname.slice(1));
          surname = (self.$store.state.user.scope.surname.charAt(0).toUpperCase() + self.$store.state.user.scope.surname.slice(1));
          if (self.$store.state.user.scope.display_name && self.$store.state.user.scope.use_display_name) {
            return self.$store.state.user.scope.display_name
          }
          return firstname + ' ' + surname
        }
      },
      upperTwoInitials: {
        get() {
          let self = this;
          if (self.$store.state.user.scope.display_name && self.$store.state.user.scope.use_display_name) {
            return self.$store.state.user.scope.display_name.charAt(0).toUpperCase()
          }
          return self.$store.state.user.scope.firstname.charAt(0).toUpperCase() + self.$store.state.user.scope.surname.charAt(0).toUpperCase();
        }
      }
    }
  }
</script>
<style>
  @import "./user-avatar.css";
</style>
<style scoped>
  .blue {
    background: #e9e9e9 !important;
    color: #0179d5 !important;
  }

  .blackGradient {
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#000000+0,000000+100&0+0,0.65+100 */
    background: -moz-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#a6000000', GradientType=0); /* IE6-9 */
    position: absolute;
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// UserAvatar.vue?2c4f2f8c